module.exports = __webpack_public_path__ + "img/fineness-1.be52f3e.png";